import { stringify as queryStringify } from 'query-string';

import type { EntityApplicationOutcome, JourneyApplicationOutcome } from './types';

export const ACTION_NODE_TYPES = {
  CUSTOM_REVIEW: 'custom_review',
  END_USER: 'end_user',
  EVENT_ACTION: 'event_action',
  PARENT_REVIEW: 'parent_review',
  SERVICE: 'service',
} as const;

export type ActionNodeType = typeof ACTION_NODE_TYPES[keyof typeof ACTION_NODE_TYPES];

export const JOURNEY_OUTCOMES: JourneyApplicationOutcome[] = [
  'Approved',
  'Denied',
  'Review',
];

export const ENTITY_OUTCOMES: EntityApplicationOutcome[] = [
  'Approved',
  'Denied',
  'Withdrawn',
];

export const NO_CONNECTION_TYPES = [
  'addNodeForm',
  'input',
  'outcome',
  'retry',
  'simple',
  'start',
  'resume',
];

export const WORKFLOW_QUERY_PARAMS = queryStringify({
  paginateBy: 1000,
});

export const NON_ACTIVE_WORKFLOW_VERSION_MESSAGE = 'This is a non-active Workflow version.';

// Journey Builder Validation Messages
export const ARCHIVED_ACTION_MESSAGE = 'This Action has been archived. Please use a different action.';
export const ARCHIVED_WORKFLOW_MESSAGE = `This workflow has been archived. Please restore the
  workflow or switch to a different workflow.`;
export const ARCHIVED_RECON_WORKFLOW_MESSAGE = 'This Reconciliation workflow has been archived. Please ';
export const ARCHIVED_RECON_WORKFLOW_BUTTON_MESSAGE = 'click to restore the workflow';
export const COULD_NOT_SAVE_JOURNEY_MESSAGE = 'Couldn\'t save journey. Please correct the errors to save.';
export const NO_OUTCOMES_MESSAGE = `This workflow does not have any outcomes configured, which
  leaves it unconnected to a terminal outcome. Edit the workflow logic to add outcomes.`;
export const NO_RECON_OUTCOME_LOGIC_MESSAGE = `There is no Reconciliation Outcome logic set up.
  Please set up your Reconciliation logic.`;
export const NO_RECON_WORKFLOW_MESSAGE = `There is no Reconciliation workflow logic set up. Please
  set up your Reconciliation workflow, with at least one outcome.`;
export const NO_RECON_WORKFLOW_MESSAGE_PT_2 = ` if you have created and saved a version for your Reconciliation
  workflow.`;
export const NO_TERMINAL_OUTCOME_MESSAGE = `This path is not connected to a terminal outcome.
  Please continue adding logic or add a terminal outcome.`;
export const UNNAMED_BRANCH_MESSAGE = `There is an unnamed branch in your Journey. Please name
  all branches.`;
export const MISSING_RECON_WORKFLOW_IN_GRAPH = 'There is no Reconciliation Workflow linked to this Entity Outcome.';
export const PE_SOURCE_WORKFLOW_DEFAULT_TERMINAL_OUTCOME_MESSAGE = `The default outcome from a Portfolio Workflow will never
  generate an Alert or Application and therefore always results in a "Dismissed" Journey outcome.`;
